import React, { Component } from "react";
import ImageWithFallback from "./ImageWithFallback";
export default class CarImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      image: null,
      isloaded: false,
    };
  }
  componentDidMount() {}
  componentDidUpdate(prevProps, prevState) {}
  setIsLoaded = () => {
    this.setState({
      isloaded: true,
    });
  };

  // Usage

  render() {
    const { data } = this.props;

    return (
      <>
        <div className="carImage">
          <ImageWithFallback
            key={`${data.komnr}-${data.model}`}
            src={data.img}
            fallbackUrls={[
              `./assets/models/${data.komnr}.avif`, // Second try local URL
              `./assets/placeholder/${data.model}_siluett.jpg`, // Third try placeholder
            ]}
            alt={data.kirjeldus}
            className="currentImage"   
            lastFallbackClassName="currentImage placeholder-image"
          />
        </div>
          <img
            className="badge"
            src="./assets/images/suvepakett_redbg.svg"
            alt="suvepakett"
          />
      </>
    );
  }
}


/*

  {data.staatus === "Laos" && data.model === "Cayenne" ? (
          <img
            className="badge"
            src="./assets/images/suvepakett_redbg.svg"
            alt="suvepakett"
          />
        ) : (
          <img className="badge" src="./assets/images/laos.svg" alt="laos" />
        )}

*/